import axiosInstance from "../api/axiosInstance";
import { encryptData, decryptData } from "shared/utils/cryptoUtils";

export const loginService = async (username, password) => {
  try {
    // 1. Ciframos las credenciales
    const encryptedCredentials = await encryptData({
      username: username.trim(),
      password,
    });

    // 2. Enviamos al backend
    const { data } = await axiosInstance.post("/api/auth/login", {
      body: encryptedCredentials,
      headers: {
        "X-Encrypted-Payload": "true",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const data2 = await decryptData(data);
    return data2;
  } catch (error) {
    const status = error.response?.status;
    const invalidCredentials = status === 401 || status === 403;
    const message = invalidCredentials
      ? "Credenciales inválidas o acceso denegado"
      : status === 429
      ? "Demasiados intentos. Intenta de nuevo más tarde."
      : error.response
      ? "El servidor no pudo completar el acceso. Intenta de nuevo."
      : error.request
      ? "No se pudo conectar con el servidor. Revisa tu conexión."
      : "No se pudo procesar la respuesta de autenticación.";
    const authError = new Error(message);
    authError.invalidCredentials = invalidCredentials;
    authError.status = status;
    throw authError;
  }
};
